import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const UnsignedRoute = ({ component: Component, isLoggedIn, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        !isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/${sessionStorage.currentProject || ""}`} />
        )
      }
    />
  );
};

UnsignedRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
};

const mapStateProps = state => ({
  isLoggedIn: state.auth.userData.userType
});

export default connect(mapStateProps)(UnsignedRoute);
